import React, {useState} from "react";

type FilterQueryType = {
  urlFilterQueryCtx: string,
  setUrlFilterQueryCtx: React.Dispatch<React.SetStateAction<string>>
}

export const UrlAttrFilterQueryContext = React.createContext<FilterQueryType>({} as FilterQueryType);

export function UrlAttrFilterQueryProvider({children}: any) {
  const [urlFilterQueryCtx, setUrlFilterQueryCtx] = useState("")

  return (
    <UrlAttrFilterQueryContext.Provider value={{urlFilterQueryCtx, setUrlFilterQueryCtx}}>
      {children}
    </UrlAttrFilterQueryContext.Provider>
  )
}